export type DeleteTarget =
  | { kind: 'layer'; id: string }
  | { kind: 'effect'; id: string }
  | { kind: 'interval'; id: number }
  | null;

/** Decide what a Delete/Backspace keypress should remove given the editor's
 *  current selection. An active layer takes precedence, then a selected
 *  timeline effect section, then a selected scene; when none is selected,
 *  nothing is deleted. */
export function resolveDeleteTarget(
  { activeLayerId, selectedIntervalId, activeEffectSectionId }: {
    activeLayerId: string | null;
    selectedIntervalId: number | null;
    activeEffectSectionId?: string | null;
  },
): DeleteTarget {
  if (activeLayerId != null) return { kind: 'layer', id: activeLayerId };
  if (activeEffectSectionId != null) return { kind: 'effect', id: activeEffectSectionId };
  if (selectedIntervalId != null) return { kind: 'interval', id: selectedIntervalId };
  return null;
}
